import { render, staticRenderFns } from "./ObjectLayout.vue?vue&type=template&id=4c1eabcd&"
import script from "./ObjectLayout.vue?vue&type=script&lang=ts&"
export * from "./ObjectLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports